"use client";

import { usePageTitle } from "@/contexts/PageTitleContext";
import { ChevronRight } from "lucide-react";
import type React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/utils";

interface BreadcrumbProps {
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ className = "" }) => {
  const { title, breadcrumbs } = usePageTitle();

  if (!title && breadcrumbs.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex items-center min-w-0", className)}>
      {breadcrumbs.length > 0 ? (
        <nav className="flex items-center space-x-1 min-w-0">
          {breadcrumbs.map((item, index) => (
            <div key={item.label} className="flex items-center min-w-0">
              {index > 0 && (
                <ChevronRight size={12} className="text-text-tertiary mx-1 flex-shrink-0" />
              )}
              {item.path ? (
                <Link
                  to={item.path}
                  className="text-text-tertiary hover:text-text-secondary transition-colors text-s truncate max-w-[200px]"
                  title={item.label}
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className="text-text-primary font-medium text-sm truncate max-w-[300px]"
                  title={item.label}
                >
                  {item.label}
                </span>
              )}
              {item.badge && (
                <span className="ml-1.5 flex flex-shrink-0 items-center">{item.badge}</span>
              )}
            </div>
          ))}
        </nav>
      ) : (
        <h1 className="text-text-primary font-medium text-sm truncate max-w-[400px]" title={title}>
          {title}
        </h1>
      )}
    </div>
  );
};

export default Breadcrumb;
